import ConnectionsWidget from './connections-widget';
import React, { Component, PropTypes } from 'react';
import FindNewPartners from './find-new-partners';

class LeftNav extends Component {

  render() {
    const { history } = this.props;

    return (
      <div className={this.props.className}>
        <div className="connections-left-nav-inner">
          <div className="connections-left-nav-heading">Partner Requests</div>
          <ConnectionsWidget {...this.props} />
          <FindNewPartners
            history={history}
          />
        </div>
      </div>
    );
  }
}

LeftNav.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  tags: PropTypes.array,
  addOrRemoveTag: PropTypes.func,
};

export default LeftNav;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-left-nav/connections-left-nav.jsx